import * as React from "react";
const HeadingThree = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 7H6v5h6V7h-1V6h3v1h-1v11h1v1h-3v-1h1v-5H6v5h1v1H4v-1h1V7H4V6h3v1Zm12 5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-3v-1h3v-2h-2v-1h2v-2h-3v-1h3Z" }));
HeadingThree.displayName = "HeadingThree";
var HeadingThree_default = HeadingThree;
export {
  HeadingThree_default as default
};
